export const timeOptions = Array.from({ length: 24 }).reduce(
  (options: string[], _, hour) => {
    const m = hour > 12 ? 'PM' : 'AM';
    let formattedHour = hour == 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return [
      ...options,
      ...[
        `${formattedHour}:00 ${m}`,
        `${formattedHour}:15 ${m}`,
        `${formattedHour}:30 ${m}`,
        `${formattedHour}:45 ${m}`,
      ],
    ];
  },
  [] as string[],
);
